"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var store_1 = require("../store/store");
var oneRecipientSelectedAction_1 = require("../actions/oneRecipientSelectedAction");
exports.default = satcheljs_1.mutator(oneRecipientSelectedAction_1.default, function (actionMessage) {
    if (actionMessage.persona.EmailAddress && actionMessage.persona.EmailAddress.EmailAddress) {
        store_1.default.isLoading = true;
        store_1.default.isError = false;
    }
});
//# sourceMappingURL=oneRecipientSelectedMutator.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-subject-picker-store/lib/mutators/oneRecipientSelectedMutator.js
// module id = 2154
// module chunks = 2 3 4 45 108